import { Fragment, useState } from 'react';
import { useParams } from 'react-router';
import { IPage } from '../Components/Page';
import Title from '../Components/Title';
import { useActions } from '../Hooks/Actions';
import { useNetwork } from '../Hooks/Network';
import { eventStore, IStoreGate } from '../Services/EventsStore';
import { useInitAsync } from '../Utils';
import Home from './Home';
import "./GateSelector.scss"

interface IGateSelctorProps {
    eventTitle?: string;
    gates?: IStoreGate[];
}

export function GateSelectorContent(props: IGateSelctorProps) {

    const network = useNetwork();

    const actions = useActions();

    const { eventId } = useParams();

    const [gates, setGates] = useState(props.gates);

    const [eventTitle, setEventTitle] = useState(props.eventTitle);

    useInitAsync(() => network(async () => {

        if (!gates)
            await setGates(await eventStore.updateEventGatesAsync(eventId));

        if (!eventTitle)
            setEventTitle((await eventStore.getEventByIdAsync(eventId)).title);

    }));

    const onSelect = (gate: IStoreGate) => actions.scanOrCountAsync(eventId, gate);

    return (
        <Fragment>
            <header><Title>{eventTitle}</Title></header>

            <div className="list-view">
                {gates?.map((a, i) => (
                    <div key={i} className="list-item" onClick={() => onSelect(a)}>
                        {a.name}
                    </div>
                ))}
            </div >
        </Fragment>
    );
}

const GateSelector : IPage = {

    name: "gate-selector",
    title: "Gate",
    route: "/gate/:eventId",
    container: Home,
    content: <GateSelectorContent />,
    appBar: { title: "Access Control" }
}

export default GateSelector;